import { render } from "./sidebar.vue?vue&type=template&id=b8b6e134&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=b8b6e134&scoped=true&lang=less"

import exportComponent from "D:\\Septris Remake\\septris-remake\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b6e134"]])

export default __exports__